__webpack_require__.p = "/disgaea/d7-complete/fr/";